export default __webpack_public_path__ + "03b57b1e5dad828e47853ae6647f0afa.png";